import { render, staticRenderFns } from "./AssignExam.vue?vue&type=template&id=90770cfe&scoped=true&"
import script from "./AssignExam.vue?vue&type=script&lang=js&"
export * from "./AssignExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90770cfe",
  null
  
)

export default component.exports